import { Building2 } from 'lucide-react';

interface MineSourceChipProps {
  mineSource: 'direct' | 'derived' | null;
  mineDerivedFrom: { organizationId: string; organizationName: string } | null;
}

export const MineSourceChip = ({ mineSource, mineDerivedFrom }: MineSourceChipProps) => {
  if (mineSource !== 'derived' || !mineDerivedFrom) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-[0.7rem] font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
      title={`In your Mine list via NamedAccount ownership on ${mineDerivedFrom.organizationName}`}
    >
      <Building2 className="h-3 w-3" />
      Mine via {mineDerivedFrom.organizationName}
    </span>
  );
};
